// src/Api/Support.ts
import axios, { AxiosError } from "axios";
import { axiosPost } from "../Helpers/Api";

// Models
import SupportRequestPayload from "../Models/DTOs/SupportRequestPayloadDTO";

const BACKEND_URL = process.env.REACT_APP_WEB_API_URL ?? "/";

export type SupportRequestResult = true | AxiosError;

export async function SendSupportRequest(
    payload: SupportRequestPayload,
    abortController: AbortController,
): Promise<SupportRequestResult> {
    const url = BACKEND_URL + "v1/support/contact";

    const body = {
        subject: payload.subject,
        email: payload.email,
        message: payload.message,
        user_id: payload.userId ?? undefined,
    };

    try {
        // DEBUG: log outgoing request (you can remove this later if noisy)
        console.debug("[support][api] POST", url, body);

        // If axiosPost just wraps axios.post, this is fine.
        await axiosPost<void>(url, body, abortController);

        console.debug("[support][api] POST success", url);
        return true;
    } catch (err: unknown) {
        if (axios.isAxiosError(err)) {
            console.error("[support][api] AxiosError", {
                url,
                code: err.code,
                status: err.response?.status,
                data: err.response?.data,
                message: err.message,
            });
            return err;
        }

        console.error("[support][api] Non-Axios error", {
            url,
            err,
        });

        return new AxiosError("Non-Axios error", "ERR_UNKNOWN");
    }
}


export type EnsureFreeviewResponse = {
    email: string;
    action: string;
};

export async function transmitFreeviewEmail(
    controller: AbortController,
    email: string
): Promise<EnsureFreeviewResponse> {
    const res = await fetch(`${BACKEND_URL}v1/freeview/email`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        signal: controller.signal,
        body: JSON.stringify({
            email,
            honey: "", // honeypot: must be empty for real users
        }),
    });

    if (!res.ok) {
        const text = await res.text().catch(() => "");
        throw new Error(text || `http_${res.status}`);
    }

    return (await res.json()) as EnsureFreeviewResponse;
}
